import { render, staticRenderFns } from "./RecruiterPage.vue?vue&type=template&id=7943d6e2&"
import script from "./RecruiterPage.vue?vue&type=script&lang=ts&"
export * from "./RecruiterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7943d6e2')) {
      api.createRecord('7943d6e2', component.options)
    } else {
      api.reload('7943d6e2', component.options)
    }
    module.hot.accept("./RecruiterPage.vue?vue&type=template&id=7943d6e2&", function () {
      api.rerender('7943d6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Recruiter/RecruiterPage.vue"
export default component.exports